/**
 * Find on the Vendors list (client, 2026-10-16: "Add a search bar on the
 * vendors list screen"; decision 218): every word typed must appear in the
 * vendor's name, code, account number, contact, city or a brand it carries —
 * so "rossi" finds Rossignol, and "look" finds Rossignol by its brand too.
 */
export function vendorMatches(
  vendor: {
    name: string;
    code: string;
    accountNumber: string | null;
    contactName: string | null;
    city: string | null;
  },
  term: string,
  brands: readonly string[] = [],
): boolean {
  const words = term.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = [
    vendor.name,
    vendor.code,
    vendor.accountNumber ?? '',
    vendor.contactName ?? '',
    vendor.city ?? '',
    ...brands,
  ]
    .join(' ')
    .toLowerCase();
  return words.every((word) => haystack.includes(word));
}
